import React from "react";

/**
 * Logo — the Compass brand mark (simple 4-point compass needle on a gradient
 * tile). Single source of truth for the sidebar, the landing topbar, and any
 * other in-app placement. The favicon uses the same artwork (public/favicon.svg).
 *
 * @param {number} size  rendered width/height in px (default 28)
 * @param {object} style optional style overrides
 */
export default function Logo({ size = 28, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"
         style={{ display: "block", ...style }} role="img" aria-label="Compass">
      <defs>
        <linearGradient id="compassLogoGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F18F18" />
          <stop offset="1" stopColor="#E8431A" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="100" height="100" rx="25" fill="url(#compassLogoGrad)" />
      <polygon points="50,14 40,50 60,50" fill="#ffffff" />
      <polygon points="50,14 50,50 60,50" fill="rgba(255,255,255,0.72)" />
      <polygon points="50,86 40,50 60,50" fill="rgba(255,255,255,0.55)" />
      <polygon points="50,86 50,50 60,50" fill="rgba(255,255,255,0.4)" />
      <circle cx="50" cy="50" r="8" fill="#ffffff" />
      <circle cx="50" cy="50" r="3.4" fill="#E8431A" />
    </svg>
  );
}
